import { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { setTab, setTabDisabled, setCurrentItem, setEditingNode } from 'Actions/explore'
import { setSelectedGraphItems, updateGraphNodes } from 'Actions/graph'
import { useQuery } from 'Hooks'
import { castValue, getMemberKey, getNamespaces, getNamespaceLabel, getUid, getNodeLabel, isValidJSON } from 'Services/WeaverUtils'
import { connect } from 'react-redux'
import { Button, Row, Col, Input, Layout, Form, Select } from 'antd'
import { EditableAttributeInput } from 'Components'
import {
  CheckSquareOutlined,
  FieldTimeOutlined
} from '@ant-design/icons'
import moment from 'moment'
import Feather from '@sysunite/react-feather'
import { ATTRIBUTES, NODE, RELATION } from 'Types'

EditNodeView = ({ nodes, edges, tabIsLocked, setTabDisabled, setTab, setCurrentItem, updateGraphNodes, setEditingNode, setSelectedGraphItems, isEditingNode }) ->
  [saving, setSaving] = useState(false)
  [currentNode, setCurrentNode] = useState(undefined)

  params = useQuery()
  history = useHistory()
  { url } = useRouteMatch()
  { hash }  = useLocation()

  formRef = useRef()

  generateFieldData = ->
    index = 0
    formData = _.reduce(isEditingNode.attributes(), (acc, value, key) ->
      acc = [
        acc...
        {
          name: ['attributes', index, 'key']
          value: getNamespaceLabel(key)
        }, {
          name: ['attributes', index, 'value']
          value
        }, {
          name: ['attributes', index, 'dataType']
          value: isEditingNode.getDataType(key)
        }
      ]
      index++
      acc
    , [])

  resetForm = ->
    formRef.current?.resetFields()
    formRef.current?.setFields(generateFieldData())

  useEffect( ->
    setCurrentNode(isEditingNode)
    resetForm()
    undefined
  , [isEditingNode])

  getStateUpdateFunction = (item) -> (newState) ->
    id = getUid(item)
    if currentNode instanceof Weaver.RelationNode
      updateGraphNodes({ edges: {
        edges...,
        [id]: { edges[id]..., newState... }
      }})
    else
      updateGraphNodes({ nodes: {
        nodes...,
        [id]: { nodes[id]..., newState... }
      }})

  save = (values) ->
    newAttributes = _.map(values.attributes, ({ key, value, dataType }) ->
      namespace = _.findKey(getNamespaces(), (ns) -> key.includes(ns))
      if namespace? then key = "#{namespace}#{key.split(':')[1]}"
      { key, value: castValue(dataType, value), dataType }
    )

    removedAttributes = _.reduce(currentNode.attributes(), (acc, value, key) ->
      if not attr[key]? for attr in newAttributes
        acc.push(key)
      acc
    , [])

    currentNode.unset(key) for key in removedAttributes

    _.map(newAttributes, ({ value, key, dataType }) ->
      if (key? and _.trim(key) isnt '') and (value? and _.trim(value) isnt '')
        currentNode.set(key, value, { dataType })
    )

    setSaving(true)
    await currentNode.save({ commitMessage: "Updated node via detail view." })

    setGraphState = getStateUpdateFunction(currentNode)
    setGraphState({
      id: getUid(currentNode)
      label: getNodeLabel(currentNode)
    })

    if currentNode instanceof Weaver.RelationNode
      node = edges[getUid(currentNode)]
      setSelectedGraphItems({ edges: [getUid(currentNode)] })
    else
      node = nodes[getUid(currentNode)]
      setSelectedGraphItems({ nodes: [getUid(currentNode)] })

    setCurrentItem({
      node...
      type: ATTRIBUTES
      memberKey: getMemberKey()
      viewType: undefined
    })

    close()

  getDataType = (fieldKey) ->
    { attributes } = formRef.current.getFieldsValue()
    attributes[fieldKey]?.dataType

  setDataType = (i, dataType) ->
    { attributes } = formRef.current.getFieldsValue()
    value = castValue(dataType, attributes[i].value)
    attributes[i] = { attributes[i]..., value, dataType }
    formRef.current.setFieldsValue({ attributes: [attributes...] })

  close = ->
    setEditingNode(undefined)

  <Layout style={{ overflow: 'auto', borderRadius: '5px', background: 'var(--background)', padding: '16px' }}>
    <Row align="middle">
      <Col style={{ flex: 1 }}>
        <h1>Edit {getNodeLabel(currentNode)}</h1>
      </Col>
      <Col>
        <Button onClick={close} size="large" type="link"><Feather type="x"/></Button>
      </Col>
    </Row>
    <Form layout="vertical" onFinish={save} ref={formRef}>
      <Form.List name="attributes">
        {(fields, { add, remove }) ->
          <div>
            {
              fields.map((field, i) ->
                <Form.Item data-testid="attribute-form-item" key={field.key}>
                  <Row gutter={8} type="flex">
                    <Col style={{ flex: 3 }}>
                      <Form.Item name={[field.name, 'key']}>
                        <Input data-testid="attr-key"/>
                      </Form.Item>
                    </Col>
                    <Col style={{ flex: 3 }}>
                      <Form.Item name={[field.name, 'value']} valuePropName={if getDataType(i) is 'boolean' then 'checked' else 'value'}>
                        <EditableAttributeInput
                          data-testid="attr-value"
                          type={getDataType(i)}
                          valueKey={field.value}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ flex: 1 }}>
                      <Form.Item name={[field.name, 'dataType']}>
                        <Select data-testid="attribute-type" onChange={(val) -> setDataType(i, val)}>
                          <Select.Option value="json"><span data-testid="json">JSON</span></Select.Option>
                          <Select.Option value="string"><span data-testid="string">Text</span></Select.Option>
                          <Select.Option value="multiline"><span data-testid="multiline">Multiline</span></Select.Option>
                          <Select.Option value="wvr:fileId"><span data-testid="file">File</span></Select.Option>
                          <Select.Option value="double"><span data-testid="double">Number</span></Select.Option>
                          <Select.Option value="date"><span data-testid="datetime"><FieldTimeOutlined /></span></Select.Option>
                          <Select.Option value="boolean"><span data-testid="boolean"><CheckSquareOutlined /></span></Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button data-testid="remove-attribute" type="link" onClick={->
                        remove(field.name)
                      }><Feather type="x" /></Button>
                    </Col>
                  </Row>
                </Form.Item>
              )
            }
            <Form.Item>
              <Button data-testid="add-attribute" onClick={-> add()} type="dashed" block>
                <Feather type="plus" /> Add attribute
              </Button>
            </Form.Item>
          </div>
        }
      </Form.List>
      <Form.Item style={{ float: 'right' }}>
        <Button data-testid="discard" style={{ marginRight: '12px' }} onClick={resetForm}>Discard</Button>
        <Button data-testid="save" htmlType="submit" loading={saving} type="primary" disabled={!currentNode}>Save</Button>
      </Form.Item>
    </Form>
  </Layout>


export default connect(({ explore, graph: { graphData: { nodes, edges }}}) ->
  { isEditingNode: explore.isEditingNode, nodes, edges, tabIsLocked: explore.tabIsLocked }
, { setTab, setTabDisabled, setCurrentItem, updateGraphNodes, setEditingNode, setSelectedGraphItems }
)(EditNodeView)
